module.exports = __webpack_public_path__ + "358505aac8501513872c022e07f4916f.png";